import { render, staticRenderFns } from "./SaleOrder.vue?vue&type=template&id=21c65259&scoped=true&"
import script from "./SaleOrder.vue?vue&type=script&lang=js&"
export * from "./SaleOrder.vue?vue&type=script&lang=js&"
import style0 from "./SaleOrder.vue?vue&type=style&index=0&id=21c65259&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c65259",
  null
  
)

export default component.exports